import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { SeaMapPage } from './SeaMapPage';
import { SightingsMapPage } from './SightingsMapPage';

/** sea-map（担当: G4）。S-72 海域図（事前連絡・実績）／S-73 海域図（視認・漁具）。全ロール（漁協は自組織） */
export const routes: RouteObject[] = [
  {
    path: 'sea-map',
    handle: { crumb: '海域図' } satisfies RouteHandle,
    element: (
      <RequireAuth>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <SeaMapPage /> },
      { path: 'sightings', element: <SightingsMapPage />, handle: { crumb: '視認・漁具' } satisfies RouteHandle },
    ],
  },
];
